module.exports = __webpack_public_path__ + "06_face.f7d75df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/06_face.png
// module id = JXV4
// module chunks = 0